export enum UserRole {
  melder = 109,
  administrator = 110,
  leidinggevende = 111,
  caseManager = 112,
  personeelszaken = 113,
  kijkerVerzuim = 114,
  manager = 115,
  rapporteur = 116,
  gebruikersbeheer = 117,
  aaMelder = 118,
  oudLeidinggevende = 119,
  zelfPlanner = 133,
  ico1sz = 143,
  icoAv = 135,
  contractbeheer = 139,
  callcenter = 141,
  hulprolBeheerZvdZAccount = 904,
  interventieDesk = 916,
  eenSzProcesregisseur = 918,
  medischeDienstVerzekeraar = 919,
  meekijkRapporteur = 926,
  zelfPlanMelder = 928,
  kijkerVerzuimVerzekeraar = 936,
  casemanagerVerzekeraar = 937,
}

export function getUserRoles(): {
  id: UserRole;
  name: string;
  i18nKey: string;
}[] {
  return (
    Object.keys(UserRole).filter(value =>
      Number.isNaN(Number(value)),
    ) as (keyof typeof UserRole)[]
  ).map(name => ({
    name,
    id: UserRole[name],
    i18nKey: `roleName.${name}`,
  }));
}
